import _ from 'lodash';
import AmpersandCollection from 'ampersand-collection';
import CustomFieldModel from './gd-custom-field';


const GDCustomFields = AmpersandCollection.extend({
    model: CustomFieldModel,

    comparator: "sortPosition",

    exportItems() {
        return this.map((model)=>{
            return {
                'value': model.id,
                'label': model.name
            }
        });
    },

    filterByCompany(companyId, includeDeleted = false) {
        return new GDCustomFields(this.filter((m)=>m.companyId === companyId && (!m.isDeleted || includeDeleted))).sort();
    },

    taskAndProject() {
        return new GDCustomFields(this.filter((m)=>{
            return m.companyId === gd.companyId && !m.isDeleted && !_.isEqual(_.get(m,'params.scope'), [3])
        })).sort();
    },

    resetAndMarkOldModelsAsDeleted(data, companyId) {
        const previousCollectionModels = _.clone(this.models)

        if (companyId) {
            this.resetByCompany(companyId, data)
        } else {
            this.reset(data, {parse:true})
        }

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                model.isDeleted = true
                this.add(model)
            }
        })
    },

    resetByCompany(companyId,newData) {
        const oldTasks = this.filter((taskType)=>{
            return taskType.companyId === companyId;
        });

        _.each(oldTasks,(model)=>{this.remove(model,{ silent: true });});

        this.add(newData,{parse:true});
    },

    filterByName(name, lowerCase = true) {
        return this.filter(m=>(lowerCase ? m.name.toLowerCase() : m.name) === name);
    },

    exportOptions() {

        const getIcon = (type)=>{
            return gd.const.customFields[type].icon || '';
        };


        return this.filter(m=>!m.isDeleted && gd.const.customFields[m.type]).map((m)=>{
            return {
                value: m.id,
                label: m.name,
                icon: getIcon(m.type),
                access: m.access,
                scope: _.get(m.params, 'scope', gd.const.customFields.scope.TASK)
            }
        })
    }

});


module.exports = GDCustomFields;